import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { IncidentResponse, IncidentView, selectIncidentsFromReview } from '@tokeet-frontend/incident'
import { ChannelReviewItem, ReviewService } from '@tokeet-frontend/reviews'
import { RejectTask, selectTasksByIncidentIds, TaskResponse } from '@tokeet-frontend/tasks'
import {
  ActionFailed,
  ConfirmDialogService,
  Destroyable,
  isSomething,
  untilDestroy,
} from '@tokeet-frontend/tv3-platform'
import { OpenEditIncidentDialog, OpenEditTaskDialog, OpenInquiryOverlay } from '@tv3/store/overlay/overlay.actions'
import * as lodash from 'lodash'
import { filter, map, switchMap } from 'rxjs/operators'

@Component({
  selector: 'app-review-draft-tasks',
  templateUrl: './review-draft-tasks.component.html',
  styleUrls: ['./review-draft-tasks.component.scss'],
})
export class ReviewDraftTasksComponent extends Destroyable implements OnInit {
  items: {
    incident: IncidentView
    task: TaskResponse
    review: ChannelReviewItem
  }[] = []
  get count() {
    return this.items.length
  }

  constructor(
    private store: Store<any>,
    private confirmDialog: ConfirmDialogService,
    private reviewService: ReviewService
  ) {
    super()
  }

  ngOnInit(): void {
    this.store
      .select(selectIncidentsFromReview)
      .pipe(
        switchMap((incidents) => {
          const incidentsById = lodash.keyBy(incidents, 'pkey')
          return this.store.select(selectTasksByIncidentIds(incidents.map((incident) => incident.pkey))).pipe(
            map((tasks) => tasks.filter((task) => task.draft)),
            filter(isSomething),
            switchMap((tasks) => {
              const reviewIds = lodash.compact(tasks.map((t) => incidentsById[t.incident_id]?.review_id))
              return this.reviewService.searchReviews({ ids: reviewIds }).pipe(
                map((response) =>
                  lodash.compact(tasks.map((t) => incidentsById[t.incident_id])).map((incident) => ({
                    incident,
                    task: tasks.find((t) => t.incident_id === incident.pkey),
                    review: response.reviews.find((r) => r._id === incident.review_id),
                  }))
                )
              )
            })
          )
        }),
        untilDestroy(this)
      )
      .subscribe(
        (items) => {
          this.items = items
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  onViewBooking(inquiryId: string) {
    this.store.dispatch(OpenInquiryOverlay({ inquiryId }))
  }

  onIncident(incident: IncidentResponse) {
    this.store.dispatch(OpenEditIncidentDialog({ incidentId: incident.pkey }))
  }

  onViewTask(task: TaskResponse) {
    this.store.dispatch(OpenEditTaskDialog({ taskId: task.pkey }))
  }

  onRejectTask(task: TaskResponse) {
    this.confirmDialog
      .confirm({
        title: $localize`Reject Task`,
        body: $localize`Are you sure you want to reject this task?`,
      })
      .subscribe(() => {
        this.store.dispatch(RejectTask({ taskId: task.pkey }))
      })
  }

  onApproveTask(task: TaskResponse) {
    this.store.dispatch(OpenEditTaskDialog({ taskId: task.pkey }))
  }
}
